import { FuncResponse, FuncResponseType, FunctionBase } from "../../storyV2/function/FunctionBase";
export class UnknownFunction extends FunctionBase {
    async run(input, identityInfo) {
        return new FuncResponse(FuncResponseType.TEXT, input);
    }
}
